import { render, staticRenderFns } from "./people.vue?vue&type=template&id=49ccc6eb&"
import script from "./people.vue?vue&type=script&lang=js&"
export * from "./people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports